import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

const SHIELD_PATH =
  'M14.833 8.52588C14.833 10.743 14.1749 12.7845 12.8672 14.6372C11.5542 16.4972 9.85847 17.7016 7.78809 18.2192L7.66699 18.2495L7.54492 18.2192C5.47468 17.7015 3.77969 16.4971 2.4668 14.6372C1.15897 12.7844 0.5 10.7431 0.5 8.52588V3.22119L0.824219 3.1001L7.49121 0.600098L7.66699 0.533691L7.8418 0.600098L14.5088 3.1001L14.833 3.22119V8.52588Z';

const SHIELD_ICON_PROPS = {
  viewBox: '0 0 16 19',
  style: { height: '16px', width: '16px' },
};

export const DriverCdlVerificationShieldIcon = createSvgIcon(
  'DriverCdlVerificationShield',
  <path
    d={`${SHIELD_PATH}M7.33301 12.8901H8V12.2231H7.33301V12.8901ZM7.33301 9.55615H8V5.55615H7.33301V9.55615Z`}
    fill="currentColor"
    stroke={ColorDynamic.White}
  />,
  {
    ...SHIELD_ICON_PROPS,
    htmlColor: ColorDynamic.Yellow300,
  },
);

export const DriverCdlVerificationVerifiedShieldIcon = createSvgIcon(
  'DriverCdlVerificationVerifiedShield',
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d={`${SHIELD_PATH}M10.72 6.42L6.72 10.86L4.95 9.02L4.2 9.74L6.75 12.4L11.5 7.12Z`}
    fill="currentColor"
    stroke={ColorDynamic.White}
  />,
  {
    ...SHIELD_ICON_PROPS,
    htmlColor: ColorDynamic.Green500,
  },
);
